import { styled } from "../../../theme";
import { FlexColumn } from "../../../box";
/**
 * OptionItem as container for Radio or Checkbox.
 */
export const OptionItem = styled(FlexColumn) `
  margin-right: 10px;
  /**
   * The full-width is important for the OptionChildren to be rendered at full-width.
   */
  width: 100%;
`;
export const OptionItemChildren = styled.div `
  margin-left: 50px;
`;
